import React from "react";
import streamslogo from "../../assets/image/miniLogo.jpg";

const Loader = ({ isLoading }) => {
  return (
    <div id="overlayer" style={{ display: !isLoading && "none" }}>
      <img src={streamslogo} alt="Logo" className="spin" />

      <div className="loader">
        <span className="loader-inner"></span>
      </div>
    </div>
  );
};

export default Loader;